import type { RouteRecordRaw } from 'vue-router';

export const notificationsRoutes: RouteRecordRaw[] = [
  {
    path: '/notifications',
    name: 'notifications',
    component: () =>
      import('@/views/private/notifications/NotificationListing.vue'),
    meta: {
      title: 'Notificações',
      requiresAuth: true,
    },
  },
];
